import {
  Accordion,
  Badge,
  Checkbox,
  ChevronIcon,
  Divider,
  Group,
  Stack,
  Text,
} from '@mantine/core';
import { PluginSettingItem } from '../plugin-setting-item';
import { HiCog } from 'react-icons/hi';
import type { Setting } from '@morph-mapper/plugins';

interface PluginAccordionItemProps {
  plugin: {
    key: string;
    name: string;
    version: string;
    description?: string;
    settings: Setting[];
  };
  checked: boolean;
  onToggle: (plugin: {
    key: string;
    name: string;
    version: string;
    settings: Setting[];
  }) => void;
  onSettingChange: (pluginKey: string, settingKey: string, value: any) => void;
}

export const PluginAccordionItem = ({
  plugin,
  checked,
  onToggle,
  onSettingChange,
}: PluginAccordionItemProps) => {
  const hasBody = plugin.description || plugin.settings.length > 0;

  return (
    <Accordion.Item key={plugin.key} value={plugin.key}>
      <Accordion.Control
        {...(hasBody && {
          chevron: <ChevronIcon />,
        })}
      >
        <Group position="apart" style={{ width: '100%' }} noWrap>
          <Group spacing="sm" noWrap>
            <Checkbox
              checked={checked}
              onClick={(e) => e.stopPropagation()}
              onChange={() => onToggle(plugin)}
            />

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Text weight={500}>
                {plugin.name} ({plugin.version})
              </Text>
              {plugin.description && (
                <Text
                  size="sm"
                  color="dimmed"
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 500,
                  }}
                >
                  {plugin.description}
                </Text>
              )}
            </div>
          </Group>
          {plugin.settings.length > 0 && (
            <Badge leftSection={<HiCog size={12} style={{ marginTop: 5 }} />}>
              {plugin.settings.length}
              {plugin.settings.length > 1 ? ' Settings' : ' Setting'}
            </Badge>
          )}
        </Group>
      </Accordion.Control>
      {hasBody && (
        <Accordion.Panel pl={44} pr="md" py="md">
          {plugin.description}
          {plugin.description && plugin.settings.length > 0 && (
            <Divider mt={15} mb={15} />
          )}
          <Stack spacing="xs">
            {plugin.settings.map((setting) => (
              <PluginSettingItem
                key={setting.key}
                setting={setting}
                pluginkey={plugin.key}
                onSettingChange={onSettingChange}
              />
            ))}
          </Stack>
        </Accordion.Panel>
      )}
    </Accordion.Item>
  );
};
